import { apiRequest } from '../lib/httpClient'
import { pickString } from './shared/coercion'

export type SupportFormValues = {
  name: string
  phone: string
  email: string
  subject: string
  message: string
}

export type SupportPrefill = {
  name: string
  phone: string
  email: string
}

function toRecord(value: unknown): Record<string, unknown> {
  if (!value || typeof value !== 'object') return {}
  return value as Record<string, unknown>
}

function mapSupportPrefill(payload: unknown): SupportPrefill {
  const detail = toRecord(payload)
  const firstName = pickString(detail['firstName'] ?? detail['FirstName'])
  const lastName = pickString(detail['lastName'] ?? detail['LastName'])
  const fullName =
    pickString(detail['fullName'] ?? detail['FullName']) || `${firstName} ${lastName}`.trim()

  return {
    name: fullName,
    phone: pickString(detail['phone'] ?? detail['Phone']),
    email: pickString(detail['email'] ?? detail['Email']),
  }
}

export async function fetchSupportPrefill(userId: string): Promise<SupportPrefill> {
  if (!userId) {
    return { name: '', phone: '', email: '' }
  }

  const payload = await apiRequest<unknown>('user/ui/profile/initialise', {
    method: 'GET',
    query: { userId },
  })

  return mapSupportPrefill(payload)
}

export async function submitSupportForm(values: SupportFormValues): Promise<void> {
  await apiRequest<unknown>('support/ui/form/submit', {
    method: 'POST',
    body: values,
  })
}
